import {
    Autocomplete,
    Box,
    Button, Checkbox, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Paper, Radio, RadioGroup,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography
} from "@mui/material";
import "./css/PayScreen.css";
import { BillStatus, isEmpty, isNumberEmpty, OfferType, PayMedium, printDebugLog, RESYMBOL, StayType, UiButtonAction } from "../../constants/Constants";
import { useEffect, useState } from "react";
import DialogBox from "../../global/DialogBox";
import { fmtMoney } from "../../constants/commonUtils";
import { ACTUAL_ADULTS } from "../../constants/ConfigConstant";
import { BOOKINGCANCEL } from "../../constants/Permissions";
import DeleteIcon from '@mui/icons-material/Delete';

const PaymentScreen = ({
    billInformation,
    billPayInfo,
    setBillPayInfo,
    billPayAudit, bookingGenerateOperation,
    onlinePayMethod,
    epayAllowed,
    handleDeleteEntireBill, setSnpComponent, keyMapInformation, setKeyMapInformation, totalDuesAmt, cancelBillFeature, isRoleAllowed,
    handlePermanentDeleteUnpaidBill }) => {


    const INITIAL_PARTIAL_PAY = {
        id: "",
        partialAmt: 0.0,
        onlinePay: 0.0,
        cashPay: 0.0,
        payMedium: PayMedium.NOT_SELECTED,
        onlineBillPaidThrough: "",
        paidAcceptBy: "",
        paidOn: "",
        cashTendered: 0.0,
        cashReturn: 0.0,
        remarks: "",
    };

    useEffect(() => {
        printDebugLog("PaymentScreen billInformation", billInformation);
        setPartialPay(INITIAL_PARTIAL_PAY);
    }, [billInformation]);

    useEffect(() => {
        printDebugLog("PaymentScreen billPayInfo", billPayInfo);
    }, [billPayInfo])

    const [partialPay, setPartialPay] = useState(INITIAL_PARTIAL_PAY);
    const [showDialog, setShowDialog] = useState(false);
    const [cancelBill, setCancelBill] = useState(false);
    const [showPaymentListDialog, setShowPaymentListDialog] = useState(false);

    const getStatyTypePrefix = () => {
        return (billInformation?.stayType ?? StayType.DAILY) === StayType.DAILY ? "day" : "hour";
    };

    const updateGst = (mGstAllowed, cgst, sgst) => {
        printDebugLog("updateGst", mGstAllowed, cgst, sgst, billPayInfo);
        let mCgstAmt = 0.0;
        let mSgstAmt = 0.0;
        let mRoundOff = 0.0;
        let mSubTotal = Number(billPayInfo?.totalPrice ?? 0);
        let mFinalPrice = 0.0;
        const numCgst = Number(cgst ?? 0);
        const parseCgst = numCgst / 100;
        const numSgst = Number(sgst ?? 0);
        const parseSgst = numSgst / 100;
        const parseOfferDenom = Number(billPayInfo?.takenDenom ?? OfferType.No_Offer);
        const parseOfferAmt = Number(billPayInfo?.takenOffrAmt ?? 0);

        mFinalPrice = mSubTotal;
        if (parseOfferDenom === OfferType.Flat) {
            mFinalPrice -= parseOfferAmt;
        } else if (parseOfferDenom === OfferType.Percentage) {
            mFinalPrice -= (mFinalPrice * parseOfferAmt / 100);
        }
        if (mGstAllowed ?? true) {
            mCgstAmt = (mFinalPrice * parseCgst);
            mSgstAmt = (mFinalPrice * parseSgst);
        }
        mFinalPrice = mFinalPrice + mCgstAmt + mSgstAmt;
        mRoundOff = mFinalPrice.toFixed() - mFinalPrice;
        mFinalPrice = mFinalPrice + mRoundOff;

        setBillPayInfo(prev => ({
            ...prev,
            cgst: numCgst, sgst: numSgst,
            cgstAmt: mCgstAmt,
            sgstAmt: mSgstAmt,
            gstAllowed: mGstAllowed,
            roundOff: mRoundOff,
            finalPrice: mFinalPrice,
        }));
    }

    const updateOfferType = (mOfferType, mOfferAmt) => {
        printDebugLog("updateOfferType", mOfferType, mOfferAmt, billPayInfo);
        let mCgstAmt = 0.0;
        let mSgstAmt = 0.0;
        let mRoundOff = 0.0;
        let mSubTotal = Number(billPayInfo?.totalPrice ?? 0);
        let mFinalPrice = 0.0;
        const parseCgst = Number(billPayInfo?.cgst ?? 0) / 100;
        const parseSgst = Number(billPayInfo?.sgst ?? 0) / 100;
        const parseOfferDenom = Number(mOfferType ?? OfferType.No_Offer);
        const parseOfferAmt = Number(mOfferAmt ?? 0);

        mFinalPrice = mSubTotal;
        if (parseOfferDenom === OfferType.Flat) {
            mFinalPrice -= parseOfferAmt;
        } else if (parseOfferDenom === OfferType.Percentage) {
            mFinalPrice -= (mFinalPrice * parseOfferAmt / 100);
        }
        if (billPayInfo?.gstAllowed ?? true) {
            mCgstAmt = (mFinalPrice * parseCgst);
            mSgstAmt = (mFinalPrice * parseSgst);
        }
        mFinalPrice = mFinalPrice + mCgstAmt + mSgstAmt;
        mRoundOff = mFinalPrice.toFixed() - mFinalPrice;
        mFinalPrice = mFinalPrice + mRoundOff;

        setBillPayInfo(prev => ({
            ...prev,
            cgstAmt: mCgstAmt,
            sgstAmt: mSgstAmt,
            roundOff: mRoundOff,
            finalPrice: mFinalPrice,
            takenDenom: parseOfferDenom,
            takenOffrAmt: parseOfferAmt,
        }));
    };

    const getPartialPaidThrough = (val) => {
        if (val.payMedium === PayMedium.BOTH) {
            return val.onlineBillPaidThrough + "(" + val.onlinePay + ") Cash(" + val.cashPay + ")";
        } else if (val.payMedium === PayMedium.ONLINE)
            return val.onlineBillPaidThrough;
        else
            return "Cash";
    };


    const handleSetPayingAmount = (amount) => {
        const value = Number(amount);
        const parsePendingAmt = Number(totalDuesAmt ?? 0);
        if (!isNumberEmpty(value)) {
            if (value > parsePendingAmt) {
                setSnpComponent(prev => ({
                    ...prev,
                    snackBarOpen: true,
                    snackBarMsg: "Exceeds Remaining Amt i.e " + parsePendingAmt,
                }));
                setPartialPay({
                    ...partialPay,
                    partialAmt: 0, onlineBillPaidThrough: "", onlinePay: 0, payMedium: PayMedium.NOT_SELECTED, cashPay: 0, cashTendered: 0, cashReturn: 0,
                });
            } else {
                const dues = parsePendingAmt - value;
                setPartialPay({
                    ...partialPay,
                    partialAmt: value, onlineBillPaidThrough: "", onlinePay: 0, payMedium: PayMedium.NOT_SELECTED, cashPay: 0, cashTendered: 0, cashReturn: 0,
                });
                setBillPayInfo(prev => ({
                    ...prev,
                    duesAmt: dues
                }));
            }
        } else {
            setPartialPay({
                ...partialPay,
                partialAmt: value, onlineBillPaidThrough: "", onlinePay: 0, payMedium: PayMedium.NOT_SELECTED, cashPay: 0, cashTendered: 0, cashReturn: 0,
            });
            setBillPayInfo(prev => ({
                ...prev,
                duesAmt: 0
            }));
        }
    };


    const renderPayDialog = () => {
        return (
            <Paper
                elevation={2}
                sx={{
                    padding: 2,
                    maxWidth: 600,
                    margin: "auto",
                    borderRadius: 2,
                    backgroundColor: "#fff",
                }}
            >
                <Grid container spacing={2} alignItems="center">
                    {/* Grand Total */}
                    <Grid item xs={6}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Grand Total:
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body1" color="primary" fontWeight="bold">
                            ₹ {(billPayInfo?.finalPrice ?? 0)}
                        </Typography>
                    </Grid>

                    {/* Remaining Amt To Paid */}
                    <Grid item xs={6}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Remaining Amt To Paid:
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body1" color="secondary" fontWeight="bold">
                            ₹ {totalDuesAmt ?? 0}
                        </Typography>
                    </Grid>
                    {/* Current Remaining Dues */}
                    {!cancelBill &&
                        <Grid item xs={6}>
                            <Typography variant="subtitle1" fontWeight="bold">
                                Current Remaining Dues:
                            </Typography>
                        </Grid>
                    }
                    {
                        !cancelBill &&
                        <Grid item xs={6}>
                            <Typography variant="body1" color="error" fontWeight="bold">
                                ₹ {billPayInfo?.duesAmt ?? 0}
                            </Typography>
                        </Grid>
                    }
                    {/* Enter Paying Amount (TextField) */}
                    <Grid item xs={6}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            {cancelBill ? "Return Amount" : "Enter Paying Amount:"}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            disabled={cancelBill}
                            value={partialPay?.partialAmt ?? 0}
                            onChange={(e) => handleSetPayingAmount(e.target.value)}
                            placeholder="Enter amount"
                        />
                    </Grid>
                    {/* Payment Methods */}
                    <Grid item xs={12}>
                        <FormLabel id="paymentMethod">Payment Methods:</FormLabel>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel name="onlinePay" value={""} checked={partialPay.payMedium === PayMedium.ONLINE || partialPay.payMedium === PayMedium.BOTH}
                            control={<Checkbox />} label="Online"
                            onChange={() => {
                                if (partialPay.payMedium === PayMedium.ONLINE) {
                                    setPartialPay({
                                        ...partialPay, onlineBillPaidThrough: "", payMedium: PayMedium.NOT_SELECTED,
                                        onlinePay: 0.0
                                    })
                                } else if (partialPay.payMedium === PayMedium.CASH) {
                                    setPartialPay({
                                        ...partialPay, onlineBillPaidThrough: onlinePayMethod[0], payMedium: PayMedium.BOTH,
                                        onlinePay: (partialPay.partialAmt / 2), cashPay: (partialPay.partialAmt / 2),
                                        cashTendered: 0.0, cashReturn: 0.0,
                                    })
                                } else if (partialPay.payMedium === PayMedium.BOTH) {
                                    setPartialPay({
                                        ...partialPay, onlineBillPaidThrough: "", payMedium: PayMedium.CASH,
                                        onlinePay: 0.0, cashPay: partialPay.partialAmt,
                                        cashTendered: 0.0, cashReturn: 0.0,
                                    })
                                } else {
                                    setPartialPay({
                                        ...partialPay, onlineBillPaidThrough: onlinePayMethod[0], payMedium: PayMedium.ONLINE,
                                        onlinePay: (partialPay.partialAmt)
                                    })
                                }
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Search Online Pay Method:
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Autocomplete
                            id="pOnline-select"
                            options={onlinePayMethod}
                            autoHighlight
                            variant="filled"
                            size="small"
                            fullWidth
                            disabled={partialPay.payMedium === PayMedium.CASH || partialPay.payMedium === PayMedium.NOT_SELECTED}
                            isOptionEqualToValue={(option, value) => option === value}
                            getOptionLabel={(option) => option}
                            onChange={(e, opt) => {
                                if (opt) {
                                    setPartialPay({
                                        ...partialPay, onlineBillPaidThrough: opt,
                                    });
                                } else {
                                    setPartialPay({
                                        ...partialPay, onlineBillPaidThrough: "",
                                    })
                                }
                            }}
                            value={partialPay.onlineBillPaidThrough}
                            defaultValue={partialPay.onlineBillPaidThrough}
                            renderOption={(props, option) => (
                                <Box
                                    component="li"
                                    {...props}
                                >
                                    {option}
                                </Box>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    inputProps={{
                                        ...params.inputProps,
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Enter Online Amount:
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            id="onlinePayAmt"
                            name="onlinePayAmt"
                            variant="filled"
                            size="small"
                            fullWidth
                            disabled={partialPay.payMedium !== PayMedium.BOTH}
                            value={partialPay.onlinePay}
                            onChange={(e) => {
                                if (partialPay.payMedium === PayMedium.BOTH) {
                                    let val = Number(e.target.value);
                                    if (val > partialPay.partialAmt) {
                                        setSnpComponent(prev => ({
                                            ...prev, snackBarMsg: "Exceed Total Amt " + RESYMBOL + " " + partialPay.partialAmt,
                                            snackBarOpen: true,
                                        }))
                                    } else {
                                        let cPay = partialPay.partialAmt - val;
                                        setPartialPay({
                                            ...partialPay,
                                            onlinePay: val, cashPay: cPay,
                                            cashTendered: 0.0, cashReturn: 0.0,
                                        })
                                    }

                                }
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel name="cashPay" value={""} checked={partialPay.payMedium === PayMedium.CASH || partialPay.payMedium === PayMedium.BOTH}
                            control={<Checkbox />} label="Cash"
                            onChange={() => {
                                if (partialPay.payMedium === PayMedium.CASH) {
                                    setPartialPay({
                                        ...partialPay, payMedium: PayMedium.NOT_SELECTED,
                                        cashPay: 0.0, cashTendered: 0.0, cashReturn: 0.0,
                                    })
                                } else if (partialPay.payMedium === PayMedium.ONLINE) {
                                    setPartialPay({
                                        ...partialPay, payMedium: PayMedium.BOTH,
                                        onlinePay: (partialPay.partialAmt / 2), cashPay: (partialPay.partialAmt / 2),
                                        cashTendered: 0.0, cashReturn: 0.0,
                                    })
                                } else if (partialPay.payMedium === PayMedium.BOTH) {
                                    setPartialPay({
                                        ...partialPay, payMedium: PayMedium.ONLINE,
                                        cashPay: 0.0, onlinePay: partialPay.partialAmt,
                                        cashTendered: 0.0, cashReturn: 0.0,
                                    })
                                } else {
                                    setPartialPay({
                                        ...partialPay, payMedium: PayMedium.CASH,
                                        cashPay: (partialPay.partialAmt),
                                        cashTendered: 0.0, cashReturn: 0.0,
                                    })
                                }
                            }} />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Enter Cash Amount:
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            id="cashPayAmt"
                            name="cashPayAmt"
                            variant="filled"
                            size="small"
                            fullWidth
                            disabled={partialPay.payMedium !== PayMedium.BOTH}
                            value={partialPay.cashPay}
                            onChange={(e) => {
                                if (partialPay.payMedium === PayMedium.BOTH) {
                                    let val = Number(e.target.value);
                                    if (val > partialPay.partialAmt) {
                                        setSnpComponent(prev => ({
                                            ...prev,
                                            snackBarOpen: true,
                                            snackBarMsg: "Exceed Total Amt " + RESYMBOL + " " + partialPay.partialAmt,
                                        }));
                                    } else {
                                        let oPay = partialPay.partialAmt - val;
                                        setPartialPay({
                                            ...partialPay,
                                            cashPay: val, onlinePay: oPay,
                                            cashTendered: 0.0, cashReturn: 0.0,
                                        })
                                    }

                                }
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Enter Cash Tender:
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            id="cashTender"
                            name="cashTender"
                            variant="filled"
                            size="small"
                            fullWidth
                            disabled={partialPay.payMedium === PayMedium.ONLINE || partialPay.payMedium === PayMedium.NOT_SELECTED}
                            value={partialPay.cashTendered}
                            onChange={(e) => {
                                const val = Number(e.target.value) ?? 0.0;
                                let cReturn = 0.0;
                                if (val >= partialPay.cashPay) {
                                    cReturn = val - partialPay.cashPay;
                                    setPartialPay({
                                        ...partialPay,
                                        cashTendered: val, cashReturn: cReturn,
                                    })
                                } else {
                                    setPartialPay({
                                        ...partialPay,
                                        cashTendered: val, cashReturn: 0.0,
                                    })
                                }
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Cash Return:
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body1" color="primary" fontWeight="bold">
                            ₹ {(partialPay?.cashReturn ?? 0)}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="remarks"
                            label="Enter Remarks/FeedBack"
                            name="remarks"
                            multiline={true}
                            rows={3}
                            disabled={billInformation?.billStatus === BillStatus.BILLSETTLED}
                            variant="filled"
                            size="small"
                            defaultValue={partialPay?.remarks ?? ""}
                            onChange={(e) => setPartialPay({
                                ...partialPay, remarks: e.target.value,
                            })}
                            fullWidth
                        />
                    </Grid>

                </Grid>
            </Paper>
        );
    }

    function renderPaymentListDialogForm() {
        return (
            <>
                {billPayAudit?.lpatialAmt?.length > 0 &&
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table" className="rate_card">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Initiated/Paid On</TableCell>
                                    <TableCell align="center">Pay Type</TableCell>
                                    <TableCell align="center">Accept By</TableCell>
                                    <TableCell align="center">Amount</TableCell>
                                    <TableCell align="center">Paid Through</TableCell>
                                    <TableCell align="center">Remarks</TableCell>
                                    <TableCell align="center"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {billPayAudit?.lpatialAmt.map((val) => {
                                    return (
                                        <>
                                            <TableRow
                                                className="rate_card--row"
                                                sx={{
                                                    '&:last-child td, &:last-child th': { border: 0 },
                                                    border: !val.credit ? '2px solid red' : 'none', // outer red border
                                                    borderRadius: 2, // optional: round corners
                                                    '& > *': { borderBottom: 'none' }, // removes inner cell borders
                                                }}>
                                                <TableCell align="center"><p style={{
                                                    whiteSpace: 'pre-wrap', overflowWrap: 'break-word'
                                                }}>
                                                    {val.paidOn}</p>
                                                </TableCell>
                                                <TableCell align="center"><p style={{
                                                    whiteSpace: 'pre-wrap',
                                                    overflowWrap: 'break-word', color: val.credit ? "#87a96b" : "#990000"
                                                }}>{val.credit ? "Pay to customer" : "Returned to customer"}</p></TableCell>
                                                <TableCell align="center">{val.paidAcceptBy}</TableCell>
                                                <TableCell align="center">{val.partialAmt}</TableCell>
                                                <TableCell align="center"><p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{getPartialPaidThrough(val)}</p></TableCell>
                                                <TableCell align="center"><p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: "9px" }}>{val.remarks}</p></TableCell>
                                                {
                                                    (val.canDelete ?? false) &&
                                                    <TableCell align="center">
                                                        <IconButton
                                                            size="small"
                                                            aria-label="delete"
                                                            onPointerDown={() => {
                                                                setShowPaymentListDialog(false);
                                                                handlePermanentDeleteUnpaidBill(val.id);
                                                            }}
                                                        >
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    </TableCell>
                                                }
                                            </TableRow>
                                            {
                                                !isEmpty(val?.thirdPartyTransaction?.bank_transactionId) &&
                                                <Typography variant="p"
                                                    style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: "14px", color: "#053514ff", p: 1 }}>
                                                    {"Transaction Id : " + (val?.thirdPartyTransaction?.bank_transactionId).replace("pay_", "")}
                                                </Typography>
                                            }
                                        </>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
            </>
        )
    }

    const renderDialogAction = () => {
        return (
            <>
                {
                    showDialog &&
                    <Button variant="contained" color="primary" disabled={billInformation?.billStatus === BillStatus.BILLSETTLED}
                        onPointerDown={() => {
                            setShowDialog(false);
                            bookingGenerateOperation(cancelBill ? UiButtonAction.CANCEL_BILL : UiButtonAction.PAY, partialPay, false);
                            setCancelBill(false);
                        }}>
                        {cancelBill ? "Return" : "Initiate"}
                    </Button>
                }

                {
                    (!cancelBill && showDialog && epayAllowed) &&
                    <Button variant="contained" color="primary"
                        disabled={billInformation?.billStatus === BillStatus.BILLSETTLED}
                        onPointerDown={() => {
                            setShowDialog(false);
                            bookingGenerateOperation(UiButtonAction.PAY_WITH_LINK, partialPay, false);
                        }}>
                        Initiate E-Pay
                    </Button>
                }

                <Button variant="contained" color="primary" onPointerDown={() => {
                    if (showDialog) {
                        setPartialPay(INITIAL_PARTIAL_PAY);
                        setShowDialog(false);
                    } else {
                        setShowPaymentListDialog(false);
                    }
                }}>
                    Dismiss
                </Button>
            </>
        );
    };


    return (
        <div className="pay-screen">
            <Grid container spacing={1} display="flex" sx={{ p: 2, m: 2 }}>
                <Grid item md={7} xs={12} sm={6}>
                    <Grid container spacing={1}>
                        {
                            billInformation?.billStatus === BillStatus.CANCELLED_BILL &&
                            <Grid item xs={12}>
                                <Typography variant="subtitle4" component="div"
                                    style={{
                                        fontWeight: 'bold', fontSize: '25px',
                                        color: "#751500", whiteSpace: 'pre-wrap', overflowWrap: 'break-word'
                                    }}>
                                    This bill is cancelled</Typography>
                            </Grid>
                        }
                        <Grid item xs={6} md={4} sm={4}>
                            <Typography variant="subtitle4" component="div"
                                style={{
                                    fontWeight: 'bold', fontSize: '16px', color: "#2f1160",
                                    whiteSpace: 'pre-wrap', overflowWrap: 'break-word'
                                }} >Banquet Price: ₹{billPayInfo?.totalBanquetPrice ?? 0}/{getStatyTypePrefix()}</Typography>
                        </Grid>
                        <Grid item xs={6} md={4} sm={4}>
                            <Typography variant="subtitle4" component="div"
                                style={{
                                    fontWeight: 'bold', fontSize: '16px', color: "#2f1160",
                                    whiteSpace: 'pre-wrap', overflowWrap: 'break-word'
                                }} >Room Price: ₹{billPayInfo?.totalRoomPrice ?? 0}/{getStatyTypePrefix()}</Typography>
                        </Grid>
                        <Grid item xs={6} md={4} sm={4}>
                            <Typography variant="subtitle4" component="div"
                                style={{ fontWeight: 'bold', fontSize: '16px', color: "#2f1160", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}
                            >T. Extra Price: ₹{billPayInfo?.totalExtraPrice ?? 0}</Typography>
                        </Grid>
                        <Grid item xs={6} md={4} sm={4}>
                            <Typography variant="subtitle4" component="div" style={{
                                fontWeight: 'bold', fontSize: '16px', color: "#2f1160", whiteSpace: 'pre-wrap',
                                overflowWrap: 'break-word'
                            }}
                            >T. Restaurant Price: ₹{billPayInfo?.totalRestaurantBillPrice ?? 0}</Typography>
                        </Grid>
                        <Grid item md={12} sm={12} />
                        <Grid item md={3} xs={6} sm={3}>
                            <FormControl>
                                <FormLabel id="gstOption">GST Options:</FormLabel>
                                <FormControlLabel name="isGstAllowed" disabled={billInformation?.billStatus >= BillStatus.ROOMALLOTEDPAID}
                                    value={billPayInfo?.gstAllowed ?? true}
                                    checked={billPayInfo?.gstAllowed ?? true} control={<Checkbox />} onChange={() => {
                                        const val = !billPayInfo?.gstAllowed;
                                        updateGst(val, val ? billPayInfo?.cgst ?? 0.0 : 0.0, val ? billPayInfo?.sgst ?? 0.0 : 0.0)
                                    }} label={billPayInfo?.gstAllowed ? "Disable GST" : "Enable GST"} />
                            </FormControl>
                        </Grid>

                        {
                            billPayInfo?.gstAllowed && <Grid item md={4} xs={6} sm={4}>
                                <TextField
                                    id="cgst"
                                    label="Enter CGST(%)"
                                    type="number"
                                    name="cgst"
                                    value={billPayInfo?.cgst ?? ""}
                                    disabled={billInformation?.billStatus >= BillStatus.ROOMALLOTEDPAID}
                                    variant="filled"
                                    size="small"
                                    onChange={(e) => {
                                        if (!isNumberEmpty(e.target.value)) {
                                            updateGst(billPayInfo?.gstAllowed, Number(e.target.value) ?? 0.0, billPayInfo?.sgst ?? 0.0);
                                        } else {
                                            updateGst(billPayInfo?.gstAllowed, 0.0, billPayInfo?.sgst ?? 0.0);
                                        }
                                    }}
                                    fullWidth
                                    inputProps={{ min: '0' }}
                                />
                            </Grid>
                        }
                        {
                            billPayInfo?.gstAllowed && <Grid item md={4} xs={6} sm={4}>
                                <TextField
                                    id="sgst"
                                    label="Enter SGST(%)"
                                    type="number"
                                    name="sgst"
                                    value={billPayInfo?.sgst ?? ""}
                                    disabled={billInformation?.billStatus >= BillStatus.ROOMALLOTEDPAID}
                                    variant="filled"
                                    size="small"
                                    onChange={(e) => {
                                        if (!isNumberEmpty(e.target.value)) {
                                            updateGst(billPayInfo?.gstAllowed, billPayInfo?.cgst ?? 0.0, Number(e.target.value) ?? 0.0);
                                        } else {
                                            updateGst(billPayInfo?.gstAllowed, billPayInfo?.cgst ?? 0.0, 0.0);
                                        }
                                    }}
                                    fullWidth
                                    inputProps={{ min: '0' }}
                                />
                            </Grid>
                        }
                        <Grid item xs={12} md={12} sm={9}>
                            <FormControl>
                                <FormLabel id="billOffer">Any Offer :</FormLabel>
                                <RadioGroup row aria-label="bofferDenom" name="bofferDenom" disabled={billInformation?.billStatus >= BillStatus.BILLSETTLED
                                    || (billPayInfo?.paymentInitiated ?? false)
                                }
                                    value={billPayInfo?.takenDenom ?? OfferType.No_Offer} onChange={(e) => {
                                        if (!isNumberEmpty(e.target.value)) {
                                            updateOfferType(Number(e.target.value) ?? OfferType.No_Offer, billPayInfo?.takenOffrAmt ?? 0.0);
                                        } else {
                                            updateOfferType(OfferType.No_Offer, billPayInfo?.takenOffrAmt ?? 0.0);
                                        }
                                    }
                                    }>
                                    <FormControlLabel value={OfferType.No_Offer} disabled={billInformation?.billStatus >= BillStatus.BILLSETTLED
                                        || (billPayInfo?.paymentInitiated ?? false)
                                    } control={<Radio />} label="No Offer" />
                                    <FormControlLabel value={OfferType.Flat} disabled={billInformation?.billStatus >= BillStatus.BILLSETTLED
                                        || (billPayInfo?.paymentInitiated ?? false)
                                    } control={<Radio />} label="Flat" />
                                    <FormControlLabel value={OfferType.Percentage} disabled={billInformation?.billStatus >= BillStatus.BILLSETTLED
                                        || (billPayInfo?.paymentInitiated ?? false)
                                    } control={<Radio />} label="In Percentage" />
                                    {
                                        (billPayInfo?.takenDenom > 1) &&
                                        <div>
                                            <TextField
                                                id="bofferAmt"
                                                name="bofferAmt"
                                                variant="filled"
                                                size="small"
                                                label="Enter Offer Value"
                                                disabled={billInformation?.billStatus >= BillStatus.BILLSETTLED || (billPayInfo?.paymentInitiated ?? false)}
                                                value={billPayInfo?.takenOffrAmt}
                                                onChange={(e) => {
                                                    if (!isNumberEmpty(e.target.value)) {
                                                        updateOfferType(billPayInfo?.takenDenom, Number(e.target.value) ?? 0.0);
                                                    } else {
                                                        updateOfferType(billPayInfo?.takenDenom, 0.0);
                                                    }
                                                }}
                                                style={{ width: "100%" }}
                                            />
                                        </div>
                                    }
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                    </Grid>
                </Grid>
                <Grid item md={5} xs={12} sm={6}>
                    <Grid container spacing={1}>
                        <Grid item xs={8}>
                            <TextField
                                variant="filled"
                                size="small"
                                label="Total Actual Person"
                                onChange={(e) => setKeyMapInformation(prev => {
                                    const newMap = new Map(prev);
                                    newMap.set(ACTUAL_ADULTS, e.target.value);
                                    return newMap;
                                })}
                                value={keyMapInformation.get(ACTUAL_ADULTS) ?? ""}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} sm={12}>
                            <Typography variant="subtitle4" component="div" style={{
                                fontWeight: 'bold', fontSize: '16px', color: "#2f1160", whiteSpace: 'pre-wrap',
                                overflowWrap: 'break-word'
                            }} >{`${billInformation?.stayType === StayType.DAILY ? "Total Days Stay" : "Total Hours Stay"}: ${billInformation?.totalDaysStay ?? 0}`}</Typography>
                        </Grid>
                        <Grid item xs={12} md={12} sm={12}>
                            <Typography variant="subtitle4" component="div" style={{ fontWeight: 'bold', fontSize: '16px', color: "#2f1160", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}
                            >Sub Total: ₹{billPayInfo?.totalPrice ?? 0}</Typography>
                        </Grid>
                        {
                            billPayInfo?.takenDenom === OfferType.Flat && <Grid item xs={12} md={12} sm={12}>
                                <Typography variant="subtitle4" component="div" style={{
                                    fontWeight: 'bold', fontSize: '16px', color: "rgb(189, 116, 67)", whiteSpace: 'pre-wrap',
                                    overflowWrap: 'break-word'
                                }} >Offer Applied {"(- Flat )"} {billPayInfo?.takenOffrAmt}</Typography>
                            </Grid>
                        }
                        {
                            billPayInfo?.takenDenom === OfferType.Percentage && <Grid item xs={12} md={12} sm={12}>
                                <Typography variant="subtitle4" component="div" style={{ fontWeight: 'bold', fontSize: '16px', color: "rgb(189, 116, 67)", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >Offer Applied {"(-)"} {billPayInfo?.takenOffrAmt} %</Typography>
                            </Grid>
                        }
                        {
                            billPayInfo?.gstAllowed && <Grid item xs={12} md={12} sm={12}>
                                <Typography variant="subtitle4" component="div" style={{ fontWeight: 'bold', fontSize: '16px', color: "#2f1160", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >CGST{"(" + billPayInfo?.cgst + "%):"} ₹{billPayInfo?.cgstAmt}</Typography>
                            </Grid>
                        }

                        {
                            billPayInfo?.gstAllowed && <Grid item xs={12} md={12} sm={12}>
                                <Typography variant="subtitle4" component="div" style={{ fontWeight: 'bold', fontSize: '16px', color: "#2f1160", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >SGST{"(" + billPayInfo?.sgst + "%):"} ₹{billPayInfo?.sgstAmt}</Typography>
                            </Grid>
                        }
                        {
                            (billPayInfo?.roundOff !== 0.0 || billPayInfo?.roundOff !== -0.0) &&
                            <Grid item xs={12} md={12} sm={12}>
                                <Typography variant="subtitle4" component="div" style={{
                                    fontWeight: 'bold', fontSize: '16px',
                                    color: "#A52A2A", whiteSpace: 'pre-wrap', overflowWrap: 'break-word'
                                }} >RoundOff{billPayInfo?.roundOff > 0.0 ? "(+)" : "(-)"} {fmtMoney(billPayInfo?.roundOff)}</Typography>
                            </Grid>
                        }
                        <Grid item xs={12} md={12} sm={12}>
                            <Typography variant="subtitle4" component="div" style={{ fontWeight: 'bold', fontSize: '16px', color: "#2f1160", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}
                            >Grand Total: ₹{billPayInfo?.finalPrice ?? 0}</Typography>
                        </Grid>
                        {(billInformation?.billStatus ?? BillStatus.INUI) !== BillStatus.CANCELLED_BILL &&
                            <Grid item xs={12} md={12} sm={12}>
                                <Typography variant="subtitle4" component="div"
                                    style={{
                                        fontWeight: 'bold', fontSize: '16px', color: "#063a28ff",
                                        whiteSpace: 'pre-wrap', overflowWrap: 'break-word'
                                    }} >Paid Amount: ₹{billPayInfo?.paidAmount ?? 0}</Typography>
                            </Grid>
                        }
                        {
                            ((billInformation?.billStatus ?? BillStatus.INUI) !== BillStatus.CANCELLED_BILL && (totalDuesAmt ?? 0) > 0.0)
                            && <Grid item xs={12} md={12} sm={12}>
                                <Typography variant="subtitle4" component="div" style={{
                                    fontWeight: 'bold', fontSize: '16px',
                                    color: "#2f1160", whiteSpace: 'pre-wrap', overflowWrap: 'break-word'
                                }} >Dues: ₹{totalDuesAmt ?? 0}</Typography>
                            </Grid>
                        }

                        {
                            !isEmpty(billPayInfo?.finalCheckoutDate) && <Grid item xs={12} md={12} sm={12}>
                                <Typography variant="subtitle4" component="div" style={{ fontWeight: 'bold', fontSize: '16px', color: "#2f1160", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >Final CheckOut: {billPayInfo?.finalCheckoutDate}</Typography>
                            </Grid>
                        }
                        {
                            !billPayInfo?.paymentInitiated &&
                            <Grid item md={6} xs={12} sm={6}>
                                <Button variant="contained" disabled={billPayInfo?.totalPrice === 0 || billInformation?.billStatus === BillStatus.CANCELLED_BILL} color="primary"
                                    onPointerDown={() => bookingGenerateOperation(UiButtonAction.GENERATE_ESTIMATION, null, false)}>
                                    Generate Estimation
                                </Button>
                            </Grid>
                        }
                        <Grid item md={6} xs={12} sm={6}>
                            <Button variant="contained" disabled={billPayInfo?.totalPrice === 0 || billInformation?.billStatus >= BillStatus.BILLSETTLED} color="primary"
                                onPointerDown={() => bookingGenerateOperation(UiButtonAction.SAVE_BILL, null, false)}>
                                Save Bill
                            </Button>
                        </Grid>
                        <Grid item md={6} xs={12} sm={6}>
                            <Button variant="contained" disabled={billPayInfo?.totalPrice === 0} color="primary"
                                onPointerDown={() => bookingGenerateOperation(UiButtonAction.PRINT, null, false)}>
                                Print Bill
                            </Button>
                        </Grid>
                        <Grid item md={6} xs={12} sm={6}>
                            <Button variant="contained" disabled={billPayInfo?.totalPrice === 0} color="primary"
                                onPointerDown={() => bookingGenerateOperation(UiButtonAction.PRINT, null, true)}>
                                Print Detailed Bill
                            </Button>
                        </Grid>
                        {
                            billPayInfo?.paymentInitiated && <Grid item md={6} xs={12} sm={6}>
                                <Button variant="contained" color="primary" onClick={() => {
                                    setShowPaymentListDialog(true);
                                }}>
                                    Check Payment Status
                                </Button>
                            </Grid>
                        }
                        <Grid item md={6} xs={12} sm={6}>
                            <Button variant="contained" disabled={billPayInfo?.totalPrice === 0 || billInformation?.billStatus === BillStatus.INUI
                                || billInformation?.billStatus === BillStatus.CANCELLED_BILL
                            } color="primary"
                                onClick={() => {
                                    setShowDialog(true);
                                    setCancelBill(false);
                                }}>
                                Create pay method
                            </Button>
                        </Grid>
                        {

                            cancelBillFeature && <Grid item md={6} xs={12} sm={6}>
                                <Button variant="contained" disabled={billInformation?.billStatus === BillStatus.INUI
                                    || billInformation?.billStatus === BillStatus.BILLSETTLED || billInformation?.billStatus === BillStatus.CANCELLED_BILL}
                                    color="primary"
                                    onPointerDown={() => {
                                        if (isRoleAllowed(BOOKINGCANCEL)) {
                                            const billStatus = (billInformation?.billStatus ?? BillStatus.INUI);
                                            if (billStatus <= BillStatus.ROOMALLOTEDNOTPAID) {
                                                bookingGenerateOperation(UiButtonAction.CANCEL_BILL, null, false)
                                            } else {
                                                setShowDialog(true);
                                                setCancelBill(true);
                                                setPartialPay(prev => ({
                                                    ...prev,
                                                    partialAmt: billPayInfo?.paidAmount ?? 0,
                                                }))
                                            }
                                        }
                                    }}>
                                    Cancel Bill
                                </Button>
                            </Grid>
                        }

                        <Grid item md={6} xs={12} sm={6}>
                            <Button variant="contained" disabled={billPayInfo?.paymentInitiated ||
                                billInformation?.billStatus >= BillStatus.ROOMALLOTEDPAID
                            } color="primary" onPointerDown={() => handleDeleteEntireBill && handleDeleteEntireBill()}>
                                Delete Bill
                            </Button>
                        </Grid>
                        <Grid item md={6} xs={12} sm={6}>
                            <Button variant="contained"
                                disabled={billInformation?.billStatus <= BillStatus.ROOMALLOTEDNOTPAID || billInformation?.billStatus >= BillStatus.BILLSETTLED}
                                color="primary" onPointerDown={() => bookingGenerateOperation(UiButtonAction.SETTLE, null, false)}>
                                {billInformation?.billStatus >= BillStatus.BILLSETTLED ? "Already Settled" : "Settle Bill"}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <DialogBox showDialog={showDialog}
                title={"Initiate Payment"}
                onClose={() => {
                    setPartialPay(INITIAL_PARTIAL_PAY);
                    setShowDialog(false);
                }}
                dialogContent={renderPayDialog()}
                dialogActions={renderDialogAction()} />
            <DialogBox showDialog={showPaymentListDialog}
                title={"Payment Status"}
                onClose={() => {
                    setShowPaymentListDialog(false);
                }}
                dialogContent={renderPaymentListDialogForm()}
                dialogActions={renderDialogAction()} />
        </div>
    );
}

export { PaymentScreen };